import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';

@Injectable({
  providedIn: 'root'
})
export class SocketNoticeService extends Socket {
  constructor(private _localStorageService: LocalStorageService) {
    const userDetails = JSON.parse(
      _localStorageService.getKey('user_details')
    );
    super({
      url: 'wss://api.crizac.com',
      options: {
        transports: ['websocket'],
        // reconnection: false,
        // autoConnect: false,  // Prevent auto-connection
        forceNew: true,      // Force new connection
        timeout: 5000,
        // auth: {
        //   userId: userDetails?.id,
        //   userType: 'admin',
        // },
      },
    });
  }
}
